import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Bonificacion } from '../../services/bonificaciones.service';

@Component({
  selector: 'app-detalle-bonificacion-dialog',
  templateUrl: './detalle-bonificacion-dialog.component.html',
  styleUrls: ['./detalle-bonificacion-dialog.component.scss']
})
export class DetalleBonificacionDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    bonificacion: Bonificacion,
    conceptoDescripcion: string,
    vendedorNombre: string
  }) { }
}
